import styled from 'styled-components'

const StyledSidebarContainer = styled.div`
  background-color: #1c334f;
  position: relative;
  line-height: 25px;
  height: 100%;
  overflow-y: auto;
`

StyledSidebarContainer.displayName = 'StyledSidebarContainer'

export default StyledSidebarContainer
